/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `success` - Success
 * * `error` - Error
 * * `network_error` - Network Error
 */
export enum OneCRequestStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  NETWORK_ERROR = 'network_error',
}
